import { animate, sequence, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { BlockSettings, ViewState } from '@core/models';
import { Block } from '@core/models/block/block.model';
import { StyleService } from '@app/core/services/common/styles/style.service';
import { LightboxService } from '@modules/creator/components/special-block/lightbox/services/lightbox.service';
import { OverlayService } from '@shared/services/overlay.service';

@Component({
  selector: 'app-lightbox',
  templateUrl: './lightbox.component.html',
  standalone: false,
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
      })),
      state('closed', style({
        opacity: 0,
        display: 'none',
      })),
      transition('open => closed', [
        sequence([
          animate('0.5s', style({
            opacity: 0,
          })),
          style({display: 'none'}),
        ]),
      ]),
      transition('closed => open', [
        sequence([
          style({display: 'flex'}),
          animate('0.5s', style({
            opacity: 1,
          })),
        ]),
      ]),
    ]),
  ],
})
export class LightboxComponent implements OnInit {
  @Input() specialBlock: Block;

  basicView: Block;
  photoPreviewView: Block;
  settings: BlockSettings;

  isPreviewOpened = false;
  previewElement: any;

  constructor(private lightboxService: LightboxService,
              private overlayService: OverlayService,
              private styleService: StyleService,
              private el: ElementRef,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document) {


  }


  ngOnInit(): void {
    this.basicView = this.specialBlock.children.find(item => item.settings.viewState === ViewState.BASIC_VIEW);
    this.photoPreviewView = this.specialBlock.children.find(item => item.settings.viewState === ViewState.PHOTO_PREVIEW_VIEW);
    this.settings = this.specialBlock.settings;
    this.lightboxService.closePreview();
    this.lightboxService.previewOpened.subscribe(value => {
      this.overlayService.setOverlayDisplay(value);
      this.isPreviewOpened = value;
      if (value) {
        this.document.body.style.overflow = 'hidden';
        // Po otwarciu podglądu (gdy jest już widoczny i ma realną szerokość) przeliczamy
        // tła zdjęć widoku powiększonego, by dobrać obraz w rozmiarze viewportu zamiast
        // miniatury dobranej przy starcie strony, gdy podgląd był ukryty (szerokość 0).
        const previewEl = this.el.nativeElement.querySelector('app-lightbox-preview-view');
        if (previewEl) {
          // Podwójny requestAnimationFrame — czekamy aż animacja otwarcia ustawi display:flex
          // i przeglądarka policzy layout, zanim zmierzymy szerokość.
          requestAnimationFrame(() => requestAnimationFrame(() => {
            this.styleService.recomputeLightboxPreview(previewEl);
          }));
        }
      } else {
        setTimeout(() => {
          this.document.body.style.removeProperty('overflow');
        }, 500);
      }
    });
  }
}
